import type { TStepRunStatus } from './step-run-status';

/**
 * The step number a run has actually reported as in flight, or `null` when it
 * has reported none.
 *
 * `deriveStepRunStatuses` only marks a step `running`/`paused` once the bishop
 * journal has an event for it, so a queued run — or one whose journal has not
 * arrived yet — has no such entry and yields `null`. Callers pass that straight
 * to `deriveDocumentRunningState`, which then names the state without a step
 * instead of claiming step 1 for work that has not started.
 *
 * When more than one step looks in flight (a journal that briefly reports two,
 * mid-transition) the lowest wins, so the label does not flip back and forth.
 */
export function findReportedRunStep(
  statuses: ReadonlyMap<number, TStepRunStatus>,
): number | null {
  let reportedStep: number | null = null;
  for (const [stepNumber, status] of statuses) {
    if (status !== 'running' && status !== 'paused') continue;
    if (reportedStep === null || stepNumber < reportedStep) {
      reportedStep = stepNumber;
    }
  }
  return reportedStep;
}
